import { useQuery } from 'react-query';
import AffordableWaitlistService from '../../services/affordableWaitlistService';

const affordableWaitlistService = new AffordableWaitlistService();

const useAffordableWaitlistPositionsQuery = ({
  organizationId,
  propertyId,
  bedroomCount,
  status,
  enabled = true,
}) => {
  const queryKey = [
    'getAffordableWaitlistPositions',
    organizationId,
    propertyId,
    bedroomCount,
    status,
  ];

  const { data, isLoading, refetch } = useQuery(
    queryKey,
    () =>
      affordableWaitlistService.getAffordableWaitlistPositions(
        organizationId,
        propertyId,
        bedroomCount,
        status,
        {},
      ),
    {
      refetchOnWindowFocus: false,
      enabled: enabled && Boolean(organizationId?.length && propertyId?.length),
      select: (data) => data?.positions ?? [],
    },
  );

  return {
    positions: data ?? [],
    isLoading,
    refetch,
  };
};

export default useAffordableWaitlistPositionsQuery;
